function PowerToolsFilterMenu() {
  // Helper functions
  function isVisible(el) {
    var style = window.getComputedStyle(el);
    return !(style.display === 'none')
  }

  function slideUp(target, duration, callback) {
    if (duration == 'undefined') duration = 500;
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(function() {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      if (callback) { callback(); }
    }, duration);
  }

  function slideDown(target, duration, callback) {
    if (duration == 'undefined') duration = 500;
    target.style.removeProperty('display');
    var display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(function() {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      if (callback) { callback(); }
    }, duration);
  }

  function slideToggle(target, duration, callback) {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration, callback);
    } else {
      return slideUp(target, duration, callback);
    }
  }

// Add right after slideToggle function
function initializeClearAllButton() {
  // Find all clear all buttons
  const clearAllButtons = document.querySelectorAll('.collection__clear-filter, .collection__mobile-active-clear');
  
  clearAllButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get all checkboxes and uncheck them
      const checkboxes = document.querySelectorAll('.collection__filter-checkbox input[type="checkbox"], .color-swatch__radio');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });

      // Reset any price range inputs
      const priceInputs = document.querySelectorAll('.price-range__input input');
      priceInputs.forEach(input => {
        input.value = '';
      });

      // Reset any price range sliders
      const rangeSliders = document.querySelectorAll('.range-group input[type="range"]');
      rangeSliders.forEach(slider => {
        slider.value = slider.min;
      });

      // Remove checked state from menu triggers
      const menuTriggers = document.querySelectorAll('.menu-trigger');
      menuTriggers.forEach(trigger => {
        trigger.classList.remove('checked');
        trigger.setAttribute('aria-checked', 'false');
      });

      // Reset active filters count
      const filterCount = document.querySelector('.collection-drawer__filter-count');
      if (filterCount) {
        filterCount.textContent = '(0)';
        filterCount.style.display = 'none';
      }

      // Clear active filter display
      const activeFilters = document.querySelector('.collection__active-filters');
      if (activeFilters) {
        activeFilters.innerHTML = '';
      }

      // Get the base collection URL without filters
      const baseUrl = window.location.pathname;
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      const newUrl = sortBy ? `${baseUrl}?sort_by=${sortBy}` : baseUrl;

      // If using Ajax, trigger the filter update
      if (window.powerToolsSettings && window.powerToolsSettings.ptAjaxEnabled) {
        // Trigger your existing Ajax update function
        updateFilters(newUrl);
      } else {
        // Regular page reload
        window.location.href = newUrl;
      }
    });
  });
}

// Helper function to update filters via Ajax
function updateFilters(url) {
  const filterMenus = document.querySelectorAll('.filter-menu');
  
  // Add loading state
  filterMenus.forEach(menu => {
    menu.classList.add('pt-ajax-loading');
  });

  // Fetch new content
  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newFilterMenu = doc.querySelector('.filter-menu');

      // Update each filter menu on the page
      filterMenus.forEach(oldMenu => {
        const parent = oldMenu.parentNode;
        parent.replaceChild(newFilterMenu.cloneNode(true), oldMenu);
      });

      // Reinitialize any necessary components
      if (typeof window.ptOnLoad === 'function') {
        window.ptOnLoad();
      }
    })
    .catch(error => {
      console.error('Error updating filters:', error);
    })
    .finally(() => {
      // Remove loading state
      filterMenus.forEach(menu => {
        menu.classList.remove('pt-ajax-loading');
      });
    });
}



  
  // New function for checkbox functionality
  function updateCheckboxState(menuTrigger) {
    var scrollContent = menuTrigger.nextElementSibling;
    var hasSelectedItem = scrollContent.querySelector('li.selected') !== null;
    
    if (hasSelectedItem) {
      menuTrigger.classList.add('checked');
      menuTrigger.setAttribute('aria-checked', 'true');
    } else {
      menuTrigger.classList.remove('checked');
      menuTrigger.setAttribute('aria-checked', 'false');
    }
  }

  // New function to count and display new filters
  let initialFilterSetup = false;
  function updateNewFiltersCount() {
  
    var filterMenu = document.querySelector('.filter-menu');
    if (!filterMenu) {
      return;
    }
  
    var filterGroups = filterMenu.querySelectorAll('.filter-group');
  
    if (!initialFilterSetup) {
      filterGroups.forEach(group => {
        group.setAttribute('data-initial-filter', 'true');
      });
      initialFilterSetup = true;
      return; // Exit function after initial setup
    }
  
    var newFiltersCount = 0;
  
    filterGroups.forEach(function(group, index) {
      var groupTitle = group.querySelector('h4') ? group.querySelector('h4').textContent.trim() : 'No title found';
      var isVisible = window.getComputedStyle(group).display !== 'none';
      var isInitialFilter = group.getAttribute('data-initial-filter') === 'true';
      
      if (isVisible && !isInitialFilter) {
        newFiltersCount++;
      }
    });
  
  
    var applyGroups = document.querySelectorAll('.pt-apply-group');
  
    applyGroups.forEach(function(applyGroup) {
      var newFiltersText = applyGroup.querySelector('.new-filters-text');
      if (!newFiltersText) {
        newFiltersText = document.createElement('div');
        newFiltersText.className = 'new-filters-text';
        applyGroup.insertBefore(newFiltersText, applyGroup.firstChild);
      }
      
      if (newFiltersCount > 0) {
        newFiltersText.textContent = 'Filter options have changed';
        newFiltersText.style.opacity = '1';
        newFiltersText.style.display = 'block';
        
        // Fade out after 2 seconds
        setTimeout(function() {
          newFiltersText.style.opacity = '0';
          setTimeout(function() {
            newFiltersText.style.display = 'none';
          }, 500); // Wait for fade out to complete before hiding
        }, 1000);
      } else {
        newFiltersText.style.display = 'none';
      }
    });
  
    setTimeout(function() {
      var newFiltersText = document.querySelector('.new-filters-text');
      if (newFiltersText) {
      } else {
      }
    }, 100);
  }


  
  function applyEnabled() {
    return !!window.powerToolsSettings.applyEnabled
  }

  function drawerEnabled() {
    return !!window.powerToolsSettings.drawerEnabled
  }

  function drawerEnableMobileOnly() {
    return !!window.powerToolsSettings.drawerEnableMobileOnly
  }

  function ajaxEnabled() {
    return !!window.powerToolsSettings.ptAjaxEnabled
  }

  function sortByEnabled() {
    return !!window.powerToolsSettings.ptSortByEnabled
  }

  // .matches() & .closest() polyfills
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;

      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  // On load/reload
  function ptOnLoad() {
    // Handle multiple filter menus on page
    var filterMenuContainers = document.querySelectorAll('.pt-filter-menu-container');
    var filterMenus = document.querySelectorAll('.filter-menu');

    // onLoadMq is used for drawer on mobile only setting
    var onLoadMq = window.matchMedia(`(max-width: ${window.powerToolsSettings.ptMobileMaxWidth})`);

    // Apply settings classes
    if (window.powerToolsSettings.classes) {
      filterMenuContainers.forEach((container) => {
        window.powerToolsSettings.classes.forEach(className => {
          container.classList.add(className);
        })
        
        if (drawerEnabled()) {
          filterMenuContainers.forEach((container) => {
            container.classList.remove('show-mobile-menu-btn');
          });
          
          if (drawerEnableMobileOnly()) {
            function toggleMobileDrawerClass(mq) {
              filterMenuContainers.forEach((container) => {
                mq.matches ? container.classList.add('pt-drawer-active-mobile') : container.classList.remove('pt-drawer-active-mobile');
              });
            } 
            onLoadMq.addEventListener('change', toggleMobileDrawerClass);
            toggleMobileDrawerClass(onLoadMq);
          }
        }
      })
    }

    if (window.powerToolsSettings.groupClasses) {
      document.querySelectorAll('.pt-filter-menu-container .filter-group:not(.refine-header):not(.filter-group-pt-apply-group)').forEach((element) => {
        window.powerToolsSettings.groupClasses.forEach((groupClass) => {
          element.classList.add(groupClass);
          if (sortByEnabled()) {
            document.querySelectorAll('.filter-group-sort-orders').forEach(group => {
              group.classList.add(groupClass);
            })
          }
        });
      });
    }

    if (window.powerToolsSettings.selectedClasses) {
      document.querySelectorAll('.pt-filter-menu-container .filter-group.has_group_selected').forEach((element) => {
        window.powerToolsSettings.selectedClasses.forEach((selectedClass) => {
          element.classList.add(selectedClass);
        });
      });
    }

    // Check Safari
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      document.querySelectorAll('.filter-menu').forEach(fm => fm.classList.add('is-safari'))
    }
    
    // Handle Sort By section
    if (sortByEnabled()) {
      var sortByGroup = document.querySelector('.filter-group-sort-orders')
      if (!!document.querySelector('.pt-sort-position-top')) {
        var refineHeaders = document.querySelectorAll('.filter-menu .refine-header')
        refineHeaders.forEach(header => {
          header.insertAdjacentElement('afterend', sortByGroup.cloneNode(true))
        })
      } else {
        if (applyEnabled()) {
          var applyBtns = document.querySelectorAll('.filter-menu .filter-group-pt-apply-group')
          applyBtns.forEach(btn => {
            btn.insertAdjacentElement('beforebegin', sortByGroup.cloneNode(true))
          })
        } else {
          filterMenus.forEach(fm => {
            fm.appendChild(sortByGroup.cloneNode(true))
          })
        }
      }
      // remove inline styles to allow the cloned sort-by groups to show
      document.querySelectorAll('.filter-menu .filter-group-sort-orders').forEach(group => {
        group.removeAttribute('style')
      })

      // if ajax or apply button enabled, update href in the sort orders so it matches the target url, not the current url
      var sortByOptions = document.querySelectorAll('.filter-menu [data-sort-option]');
      var currentSortOrder = new URL(window.location.href).searchParams.get('sort_by') || powerToolsSettings.ptDefaultSort;
      var applyHref = document.querySelector('.pt-apply-group').getAttribute('href');
      var filterLinks = document.querySelectorAll('.filter-group:not(.filter-group-sort-orders) li:not(.inactive) a.pt-filter-link, .filter-menu .filter-clear');
      
      if (applyEnabled() && applyHref != '#') {
        var applyUrl = new URL(applyHref, window.location.origin);
        var newCurrentSortOrder = applyUrl.searchParams.get('sort_by');
        if (newCurrentSortOrder != null) {
          currentSortOrder = newCurrentSortOrder;
        }

        for (var i = 0; i < sortByOptions.length; i++) {
          var sortOptionValue = sortByOptions[i].getAttribute('data-sort-option');
          applyUrl.searchParams.set('sort_by', sortOptionValue);
          sortByOptions[i].querySelector('a').href = applyUrl.href;
        }
      }

      // Display selected sort order
      for (var i = 0; i < sortByOptions.length; i++) {
        if (sortByOptions[i].getAttribute('data-sort-option') == currentSortOrder) {
          sortByOptions[i].classList.add('selected');
          break;
        }
      }

      // Apply selected sort order to the filter links
      Array.prototype.forEach.call(filterLinks, function (a) {
        var url = new URL(a.href);
        url.searchParams.set('sort_by', currentSortOrder);
        a.href = url.href;
      });
    }
    
    // Accordions
    var accordionGroups = document.querySelectorAll('.pt-filter-menu-container .filter-group:not(.refine-header):not(.filter-group-pt-apply-group)');
    if (accordionGroups.length > 0) {
      for (var i = 0; i < accordionGroups.length; i++) {
        // Enter or space keydown listener for keyboard users
        accordionGroups[i].querySelector('h4').addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });

        // Accessibility
        if (accordionGroups[i].classList.contains('pt-group-expanded')) {
          accordionGroups[i].querySelector('h4').setAttribute('aria-expanded', 'true');
        } else {
          accordionGroups[i].querySelector('h4').setAttribute('aria-expanded', 'false');
        }
      }

      // Expand first non-selected accordion group
      if (document.querySelectorAll('.accordion-mode-first').length > 0) {
        for (var i = 0; i < accordionGroups.length; i++) {
          if (isVisible(accordionGroups[i]) && !accordionGroups[i].classList.contains('pt-display-dropdown') && !accordionGroups[i].classList.contains('has_group_selected') && !accordionGroups[i].classList.contains('pt-display-nested')) {
            accordionGroups[i].classList.add('pt-group-expanded');
            accordionGroups[i].querySelector('h4').setAttribute('aria-expanded', 'true');
            break
          }
        }
      }
    }

    // Search
    var searchGroups = document.querySelectorAll('.pt-display-search:not(.has_group_selected)');
    for (var i = 0; i < searchGroups.length; i++) {
      var searchInput = searchGroups[i].querySelector('input.fm-search-box');
      searchInput.style.display = 'block';
      searchInput.addEventListener('keyup', function () {
        var value = this.value.toLowerCase();
        var listItems = this.closest('.filter-group').querySelectorAll('li');

        for (var i = 0; i < listItems.length; i++) {
          if (listItems[i].innerText.trim().toLowerCase().search(value) > -1) {
            listItems[i].style.display = 'inherit';
          } else {
            listItems[i].style.display = 'none';
          }
        }
      });
    }

    // Drop downs
    var dropdowns = document.querySelectorAll('.pt-display-dropdown');
    if (dropdowns.length > 0) {
      for (var i = 0; i < dropdowns.length; i++) {
        // Remove accordion classes
        if (dropdowns[i].classList.contains('pt-accordion-group')) {
          dropdowns[i].classList.remove('pt-accordion-group');
        }

        // Remove menu trigger if it already exists
        if (dropdowns[i].querySelector('.menu-trigger') != null) {
          dropdowns[i].querySelector('.menu-trigger').remove();
        }

        // Set up scroll content containers and dropdown labels
        var scrollContent = dropdowns[i].querySelector('.scroll-content')
        if (scrollContent.querySelector('li.selected')) {
          var liSelected = scrollContent.querySelectorAll('li.selected .collection-name a')
          var selected = Array.prototype.map.call(liSelected, function (element) {
            return element.innerText.trim();
          }).join(", ");
        if (selected.length < 30) {
          scrollContent.insertAdjacentHTML('beforebegin', `<div class="menu-trigger" tabindex="0" aria-label="${scrollContent.parentNode.querySelector('h4').innerText} dropdown selection collapsed">${selected}</div>`);
        } else {
          scrollContent.insertAdjacentHTML('beforebegin', `<div class="menu-trigger" tabindex="0" aria-label="${scrollContent.parentNode.querySelector('h4').innerText} dropdown selection collapsed">${scrollContent.querySelectorAll('li.selected').length} Selected</div>`);
        }
      } else {
        scrollContent.insertAdjacentHTML('beforebegin', `<div class="menu-trigger" tabindex="0" aria-label="${scrollContent.parentNode.querySelector('h4').innerText} dropdown selection collapsed"> ${scrollContent.parentNode.querySelector('h4').innerText}</div>`);
      }

      // Mouseleave listener
      dropdowns[i].querySelector('.scroll-content').addEventListener('mouseleave', function (e) {
        this.classList.remove('dropdown-open');
        slideUp(this, 200);
        this.previousSibling.setAttribute('aria-label', this.parentNode.querySelector('h4').innerText.trim() + ' dropdown selection collapsed');
      });

      // Enter or space keydown listener for keyboard users
      dropdowns[i].querySelector('.menu-trigger').addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });

      // Focus out listener for keyboard users
      dropdowns[i].querySelector('.scroll-content li:last-child').addEventListener('focusout', function (e) {
        var scrollContent = this.closest('.scroll-content');
        var menuTrigger = scrollContent.parentNode.querySelector('.menu-trigger');
        scrollContent.classList.remove('dropdown-open');
        slideUp(scrollContent, 200);
        menuTrigger.setAttribute('aria-label', scrollContent.parentNode.querySelector('h4').innerText.trim() + ' dropdown selection collapsed');
      });
    }
  }   


// Function to check if filters are actively applied
function checkForAppliedFilters() {
    const clearButtonGroup = document.querySelector('.filter-group-pt-clear-group');
    const activeFilters = document.querySelectorAll('.filter-group li.selected');
    const dropdownOpen = document.querySelector('.scroll-content.dropdown-open');
    
    if (!clearButtonGroup) return;

    clearButtonGroup.style.position = 'sticky';
    clearButtonGroup.style.bottom = '0';
    clearButtonGroup.style.zIndex = dropdownOpen ? '0' : '2';

    // Only show if there are active filters
    if (activeFilters.length > 0) {
        clearButtonGroup.style.display = 'block';
        clearButtonGroup.style.visibility = dropdownOpen ? 'hidden' : 'visible';
    } else {
        clearButtonGroup.style.display = 'none';
    }
}

// Handle dropdown visibility
document.addEventListener('click', function(e) {
    const clearButtonGroup = document.querySelector('.filter-group-pt-clear-group');
    if (!clearButtonGroup) return;

    // When clicking menu trigger button (opening dropdown)
    if (e.target.classList.contains('menu-trigger')) {
        const scrollContent = e.target.nextElementSibling;
        
        // Wait for dropdown animation
        setTimeout(() => {
            if (scrollContent.classList.contains('dropdown-open')) {
                clearButtonGroup.style.visibility = 'hidden';
                clearButtonGroup.style.zIndex = '0';
            } else {
                checkForAppliedFilters();
                clearButtonGroup.style.zIndex = '2';
            }
        }, 50);
    }

    // When clicking outside dropdowns
    if (!e.target.classList.contains('menu-trigger') && 
        !e.target.closest('.scroll-content')) {
        const dropdownOpen = document.querySelector('.scroll-content.dropdown-open');
        if (!dropdownOpen) {
            clearButtonGroup.style.visibility = 'visible';
            clearButtonGroup.style.zIndex = '2';
        }
    }
});

// Add event listener for mouseleave on dropdowns
document.querySelectorAll('.scroll-content').forEach(dropdown => {
    dropdown.addEventListener('mouseleave', () => {
        setTimeout(checkForAppliedFilters, 250); // Wait for dropdown close animation
    });
});

// Initialize
checkForAppliedFilters();

// Add observer for filter changes
const filterMenu = document.querySelector('.filter-menu');
if (filterMenu) {
    const observer = new MutationObserver(checkForAppliedFilters);
    observer.observe(filterMenu, { 
        subtree: true, 
        attributes: true, 
        attributeFilter: ['class'] 
    });
}
    
  // Sticky mode CSS
  if (powerToolsSettings.ptStickyMode == 'pt-sticky') {
    var stickySelectors = document.querySelectorAll(powerToolsSettings.ptStickySelector)
    if (stickySelectors.length > 0) {
      stickySelectors.forEach(selector => {
        selector.classList.add(powerToolsSettings.ptStickyMode)
      })
    }
  }

  // View more buttons
  for (var i = 0; i < filterMenuContainers.length; i++) {
    if (filterMenuContainers[i].classList.contains('view-more-enabled')) {
      var viewMoreGroup = filterMenuContainers[i].querySelectorAll('.filter-group:not(.filter-group-sort-orders) ul:not(.has_selected)');
      var max = powerToolsSettings.ptViewMoreMaxCount;

      for (var i = 0; i < viewMoreGroup.length; i++) {
        var listItems = Array.from(viewMoreGroup[i].querySelectorAll('li:not(.selected)'));

        if (listItems.length > (max)) {
          var itemsToHide = listItems.slice(max);

          for (var j = 0; j < itemsToHide.length; j++) {
            itemsToHide[j].style.display = 'none';
          }
          viewMoreGroup[i].insertAdjacentHTML('afterend', '<li class="view-more-link"><a href="javascript:;">' + powerToolsSettings.ptViewMoreText + '</a></li>');
        }
      }

      document.addEventListener('click', function (e) {
        if (e.target.parentNode.classList.contains('view-more-link')) {
          var children = e.target.parentNode.parentNode.querySelectorAll('li');
          for (var i = 0; i < children.length; i++) {
            if (!(isVisible(children[i]))) {
              slideDown(children[i], 150);
            }
          }
          e.target.parentNode.remove()
        }
      });
    }
  }

  // Set title attributes for tooltips
  var aTags = document.querySelectorAll('.filter-menu li a');
  for (var i = 0; i < aTags.length; i++) {
    if (aTags[i].closest('li').classList.contains('selected')) {
      aTags[i].setAttribute('title', 'Clear Filter: ' + aTags[i].innerText.trim())
    } else {
      aTags[i].setAttribute('title', 'Add Filter: ' + aTags[i].innerText.trim())
    }
  }

  // Handle nested filters - if sort by is enabled we need to return a different array index from splitUrl
  if (document.querySelectorAll('.pt-display-nested').length > 0) {
    var splitPath = function (url) {
      var splitUrl = url.split('?')[0].split('#')[0].split('/');
      return splitUrl;
    }
    var getCollection = function (url) {
      var splitUrl = splitPath(url);
      return sortByEnabled() ? splitUrl[4] : splitUrl[2];
    }
    var getTags = function (url) {
      var splitUrl = splitPath(url);
      return sortByEnabled() ? (splitUrl[5] || '').split('+') : (splitUrl[3] || '').split('+');
    }
    var getCommonCollection = function (url_top, url_nested) {
      var collection_top = getCollection(url_top);
      var collection_nested = getCollection(url_nested);
      if (collection_top !== collection_nested) {
        return 'all';
      }
      return collection_top;
    }
    var getCommonTags = function (url_top, url_nested) {
      var tags_top = getTags(url_top);
      var tags_nested = getTags(url_nested);
      return tags_top.filter(function (n) {
        return tags_nested.indexOf(n) > -1;
      });
    }
    var getCommonUrl = function (url_top, url_nested) {
      var val = powerToolsSettings.ptRoutesCollectionURL + '/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');
      var lastChar = val.slice(-1);
      if (lastChar == '/') {
        val = val.slice(0, -1);
      }
      return val;
    }
    var clearNestedParent = function () {
      var nestedGroups = document.querySelectorAll('.pt-display-nested');
      for (var i = 0; i < nestedGroups.length; i++) {
        var nestedParent = nestedGroups[i].previousElementSibling;
        var clearNested = nestedGroups[i].querySelector('a.filter-clear');
        if (!clearNested) return;
        clearNested = clearNested.getAttribute('href');
        var clearLink = nestedParent.querySelector('a.filter-clear');
        if (!clearLink) return;
        clearLink.href = getCommonUrl(clearLink.getAttribute('href'), clearNested);
      }
    }
    clearNestedParent();
  }

  // Ajax setup
  if (ajaxEnabled() && window.location.pathname.includes('/collections/')) {
    var selector = powerToolsSettings.ptAjaxSelector;
    if (applyEnabled()) {
      var elements = `${selector} .pt-apply-group, ${selector} .pagination a`;
    } else {
      var elements = `${selector} .filter-group li a, ${selector} .filter-group .filter-clear, ${selector} .pagination a`;
    }
    
    var pjax = new Pjax({
      elements: elements,
      selectors: ['title:not(svg title)', selector, '.pt-sort-by-block'],
      scrollTo: document.querySelectorAll('.pt-ajax-scroll-to-top').length > 0 ? 0 : false,
      timeout: 10000
    });
  }

  // Drawer setup
  if (drawerEnabled()) {
    function ptFilterDrawerEnable() {
      var body = document.querySelector('body');
      var drawer = document.querySelector('.pt-filter-drawer');
      var filterMenuContainer = document.querySelector('.pt-filter-menu-container');
      var drawerBtn = document.querySelector('.pt-filter-drawer-btn')
      drawerBtn.style.display = 'block';

      if (!!document.querySelector('.pt-drawer-container')) {
        document.querySelector('.pt-drawer-container').appendChild(drawer);
      } else {
        var newDrawerContainer = document.createElement('div');
        newDrawerContainer.classList = filterMenuContainer.classList;
        newDrawerContainer.classList.add('pt-drawer-container');
        newDrawerContainer.appendChild(drawer);
        body.appendChild(newDrawerContainer);
      }

      if (!!!document.querySelector('.pt-overlay')) {
        var overlay = document.createElement('div');
        overlay.classList.add('pt-overlay');
        body.appendChild(overlay);
      }
    }

    function ptFilterDrawerDisable() {
      var body = document.querySelector('body');
      var filterMenuContainer = document.querySelector('.pt-filter-menu-container:not(.pt-drawer-container)');
      var drawer = document.querySelector('.pt-filter-drawer');
      var overlay = document.querySelector('.pt-overlay');
      var drawerBtn = document.querySelector('.pt-filter-drawer-btn')
      drawerBtn.style.display = 'none';
      filterMenuContainer.appendChild(drawer);
      if (!!document.querySelector('.pt-drawer-container')) body.removeChild(document.querySelector('.pt-drawer-container'));
      if (!!document.querySelector('.pt-overlay')) body.removeChild(overlay);
    }

    if (drawerEnableMobileOnly()) {  
      function drawerModeToggle(mq) {
        mq.matches ? ptFilterDrawerEnable() : ptFilterDrawerDisable();
      }
      onLoadMq.addEventListener('change', drawerModeToggle);
      drawerModeToggle(onLoadMq);
    } else {
      ptFilterDrawerEnable();
    }
  }

  // Add 'initial-filter' class to all visible filter groups on page load
  if (!document.body.classList.contains('initial-filters-set')) {
    document.querySelectorAll('.filter-group:not(.filter-group-sort-orders):not([style*="display: none"])').forEach(function(group) {
      group.classList.add('initial-filter');
    });
    document.body.classList.add('initial-filters-set');
  }

  // Initialize checkbox functionality for menu-trigger elements
  var menuTriggers = document.querySelectorAll('.menu-trigger');
  menuTriggers.forEach(function(trigger) {
    // Add necessary attributes for accessibility
    trigger.setAttribute('role', 'checkbox');
    
    // Check if there are any selected items in the dropdown
    updateCheckboxState(trigger);
  });

  // Call updateNewFiltersCount after loading filters
  updateNewFiltersCount();

  // make the filter menu visible after any layout changes have run
  filterMenuContainers.forEach(container => {
    container.style.opacity = '1';
  });

  // custom event for ptOnLoad
  document.dispatchEvent(new CustomEvent('ptOnLoad'));
  }

// Make ptOnLoad globally available, for working with ajax themes
  window.ptOnLoad = ptOnLoad;

// Delegate event listeners
  document.addEventListener('click', function(e) {
    e.stopPropagation();
    var filterMenus = document.querySelectorAll('.filter-menu');
  
    // Default mobile button
    if (e.target.id === 'pt-nav-toggle') {
      var navToggle = e.target;
      if (e.handled !== true) {
        if (navToggle.classList.contains('active')) {
          e.target.closest('.filter-menu').classList.remove('pt-expand');
          var dropdowns = document.querySelectorAll('.pt-display-dropdown .scroll-content');
          for (var i = 0; i < dropdowns.length; i++) {
            dropdowns[i].style.display == 'none';
          }
          navToggle.setAttribute('aria-expanded', 'false');
          navToggle.setAttribute('aria-label', 'Show Filters');
        } else {
          e.target.closest('.filter-menu').classList.add('pt-expand');
          navToggle.setAttribute('aria-expanded', 'true');
          navToggle.setAttribute('aria-label', 'Hide Filters');
        }
        navToggle.classList.toggle('active');
        e.preventDefault();
        e.handled = true;
      }
    }
  
    // Accordions
    if (!e.target.classList.contains('filter-clear') && e.target.parentElement.classList.contains('pt-accordion-group')) {
      slideToggle(e.target.closest('.pt-accordion-group').querySelector('.scroll-content'), 200, function() {
        e.target.closest('.pt-accordion-group').classList.toggle('pt-group-expanded');
      });
  
      if (e.target.closest('.pt-accordion-group').classList.contains('pt-group-expanded')) {
        e.target.setAttribute('aria-expanded', 'true');
      } else {
        e.target.setAttribute('aria-expanded', 'false');
      }
      e.preventDefault();
    }
  
    // Dropdowns
    if (e.target.classList.contains('menu-trigger')) {
      var menuTrigger = e.target;
      var menuTriggerHeight = getComputedStyle(menuTrigger, null).height.replace('px', '');
      var menuTriggerWidth = getComputedStyle(menuTrigger, null).width.replace('px', '');
      var scrollContent = e.target.nextSibling;
      scrollContent.style.top = (parseInt(menuTrigger.offsetTop) + parseInt(menuTriggerHeight) - 1) + 'px';
      scrollContent.style.left = menuTrigger.offsetLeft + 'px';
      scrollContent.style.width = parseInt(menuTriggerWidth) + 'px';

      // The open dropdown overlays the Apply button (matching the live theme):
      // `.scroll-content.dropdown-open` is given `z-index:101` and the Apply group
      // sits inside `.filter-menu` at `z-index:100`, so the dropdown paints above
      // it. Its height/scroll come from CSS (`.scroll-content.dropdown-open`), so
      // we do NOT cap the height here — that is what previously forced the dropdown
      // to stop short of the Apply button.

      function dropdownA11y(scrollContent) {
        if (scrollContent.classList.contains('dropdown-open')) {
          menuTrigger.setAttribute('aria-label', menuTrigger.closest('.filter-group').querySelector('h4').innerText.trim() + ' dropdown selection expanded');
        } else {
          menuTrigger.setAttribute('aria-label', menuTrigger.closest('.filter-group').querySelector('h4').innerText.trim() + ' dropdown selection collapsed');
        }
      }

      // Open the dropdown that was clicked
      slideToggle(scrollContent, 200, function() {
        scrollContent.classList.toggle('dropdown-open');
        dropdownA11y(scrollContent);
      });

      // Update the checkbox state
      updateCheckboxState(menuTrigger);
    }
  
    // Vertical Drawer
    if (e.target.id === 'pt-filter-drawer-btn') {
      var drawer = document.querySelectorAll('.pt-filter-drawer')
      for (var i = 0; i < drawer.length; i++) {
        drawer[i].classList.add('pt-filter-drawer-open')
      }
      document.querySelector('body').classList.add('pt-no-scroll')
    }
  
    // Close drawer
    if (e.target.classList.contains('pt-overlay') || e.target.classList.contains('pt-filter-drawer-close-btn')) {
      var drawers = document.querySelectorAll('.pt-filter-drawer')
      for (var i = 0; i < drawers.length; i++) {
          drawers[i].classList.remove('pt-filter-drawer-open')
        }
        document.querySelector('body').classList.remove('pt-no-scroll')
      }
  
      // Apply button
      if (applyEnabled()) {
        if (e.target.classList.contains('pt-filter-link') || e.target.classList.contains('check-icon') || e.target.classList.contains('filter-clear')) {
          e.preventDefault()
          var currentUrl;
  
          if (e.target.classList.contains('check-icon')) {
            currentUrl = e.target.parentNode.getAttribute('href')
          } else {
            currentUrl = e.target.getAttribute('href')
          }
  
          // Fade filters out and disable them while new filters load
          filterMenus.forEach(fm => {
            fm.classList.add('pt-ajax-loading');
          })
  
          // Load new filters
          var targetUrl = currentUrl;
          var request = new XMLHttpRequest();
          request.responseType = 'document';
        
          request.open('GET', targetUrl, true);
          request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
              // Success!
              var res = this.response;
              var newFilterMenu = res.querySelectorAll('.filter-menu')[0];
  
              // Update the filters — replace IN PLACE so the refreshed
              // .filter-menu keeps its original position (ABOVE the sticky
              // Apply button) and the scroll position is preserved.
              // The previous removeChild()+appendChild() re-inserted it at the
              // END of the container (below the Apply button), which made the
              // Apply button jump above the filters and the page jump to the
              // top whenever a filter was selected.
              filterMenus.forEach(oldFilterMenu => {
                var parent = oldFilterMenu.parentNode;
                parent.replaceChild(newFilterMenu.cloneNode(true), oldFilterMenu);
              });
  
              // Set href and enable the apply button
              var applyGroups = document.querySelectorAll('.pt-apply-group');
              applyGroups.forEach(applyGroup => {
                applyGroup.setAttribute('href', currentUrl);
                applyGroup.querySelector('.pt-apply').classList.remove('pt-apply-disabled');
              });
  
              ptOnLoad();
              updateNewFiltersCount(); // Add this line to update the new filters count
  
              // If mobile accordion is enabled, open it after matching filters loaded
              var maxWidth = window.powerToolsSettings.ptMobileMaxWidth;
              var mediaQuery = `(max-width: ${maxWidth})`;
              if (!!document.querySelector('.show-mobile-menu-btn') && window.matchMedia(mediaQuery).matches) {
                document.querySelectorAll('#pt-nav-toggle').forEach(btn => {
                  btn.click();
                })
              }
            } else {
            }
          };
  
          request.onerror = function() {
          };
  
          request.send();
        }
      }
      // End Apply button
    });
  // End delegate event listeners

  // Ajax event listeners
  if (ajaxEnabled() && window.location.pathname.includes('/collections/')) {
    var body = document.querySelector('body');
    document.addEventListener('pjax:send', function() {
      body.classList.add("pt-ajax-loading");
    });
    document.addEventListener('pjax:complete', function() {
      body.classList.remove("pt-ajax-loading");
      ptOnLoad();
      // Close drawer on load
      if (drawerEnabled()) {
        document.querySelectorAll('.pt-filter-drawer').forEach(drawer => {
          drawer.classList.remove('pt-filter-drawer-open');
        });
        document.querySelector('body').classList.remove('pt-no-scroll');
      }

      powerToolsSettings.ptAjaxScript();
    });
  }

  ptOnLoad();
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelectorAll('.pt-filter-menu-container').length > 0) {
      PowerToolsFilterMenu();
    }
  });
// Initial setup
  updateNewFiltersCount();
  
  // Listen for filter selections
  document.addEventListener('click', function(e) {
    if (e.target.closest('.filter-group') || e.target.closest('.pt-filter-link')) {
      setTimeout(updateNewFiltersCount, 100); // Short delay to allow for DOM updates
    }
});